import DetailsHeaderAdminActions from '@/components/modals/workflowLogsModal/detailsHeader/DetailsHeaderAdminActions';
import StatusMarker from '@/components/modals/workflowLogsModal/StatusMarker';
import Skeleton from '@/components/Skeleton';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import { formatDistanceToNow } from 'date-fns';
import { useSelector } from 'react-redux';

const DetailsHeader = () => {
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const log = useArgSelector(selectors.workflowLogsById, activeLogId);
  const isLoadingLogById = useArgSelector(selectors.isLoading, 'getWorkflowLogById');
  const isAdmin = useSelector((state) => selectors.user(state)?.jwt?.admin);

  let timeAgo = log?.startedOn ? formatDistanceToNow(new Date(log?.startedOn))?.replace('minutes', 'mins')?.replace('hours', 'hrs') + ' ago' : null;
  timeAgo = timeAgo?.[0]?.toUpperCase() + timeAgo?.slice(1);

  if (isLoadingLogById) {
    return (
      <div className="details-header">
        <Skeleton skeletonStyle={{ width: 300, height: 16, borderRadius: 6 }} containerStyle={{ padding: 0 }} />
      </div>
    );
  }

  return (
    <div className="details-header">
      <StatusMarker log={log} />
      <h2>{log?.summary}</h2>
      {timeAgo && <span>{timeAgo}</span>}
      {isAdmin && <DetailsHeaderAdminActions />}
    </div>
  );
};

export default DetailsHeader;
